<template>
  <div class="sort">
    <!--    <div class="clearfix draggable-group select-none">
          <div class="sort-wrap float-left w-1/2">
            <div class="pr-2">
              <draggable :group="question.id" v-model="issue.items" ghost-class="ghost" chosen-class="chosen" @end="onSortEnd">
                <transition-group tag="ul" style="min-height: 100px">
                  <li v-for="item in issue.items" :key="item.id" class="sort-item">
                    <div v-html="item.content.richText"></div>
                    <template v-if="item.is_other_item">
                      <el-input v-model="item.value" placeholder="请输入" />
                    </template>
                  </li>
                </transition-group>
              </draggable>
            </div>
          </div>
          <div class="float-left w-1/2">
            <div class="pl-2 sort-result-wrap">
              <draggable :group="question.id" v-model="issue.value" ghost-class="ghost" chosen-class="chosen" @end="onSortEnd">
                <transition-group tag="ul" style="min-height: 100px">
                  <li v-for="item in issue.value" :key="item.id" class="sort-item">
                    <div v-html="item.content.richText"></div>
                    <template v-if="item.is_other_item">
                      <el-input v-model="item.value" placeholder="请输入" />
                    </template>
                  </li>
                </transition-group>
              </draggable>
            </div>
            <div class="mt-2 text-right">
              <span>{{ issue.value.length }}/{{ maxChoice }}</span>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <span>请将左面的项拖放到右面的框完成排序</span>
        </div>-->
    <div>
      <div
        v-for="(item,index) in issue.value"
        :key="item.id"
        class="sort-item-wrap"
        :class="{'sort-select-item':item.select,'text-ccc': disabled}"
        @click="onChangeState(item,index)"
      >
        <div class="sort-num" :class="{'sort-select':item.select}">
          <span>
            <template v-if="item.select">
              {{ index + 1 }}
            </template>
          </span>
        </div>
        <div class="sort-item">
          <div v-html="item.content.richText"></div>
          <template v-if="item.is_other_item">
            <relation-input
                @click.native.stop
                v-model="item.value"
                :type="item.inputType"
                :option-id="item.id"
                :question-id="question.id"
                :question-type="question.questionType"
                :max-length="item.maxLength"
                :min-length="item.minLength"
                :validate="item.validate"
            />
<!--            <el-input @click.native.stop v-model="item.value" placeholder="请输入" />-->
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import RelationInput from '@/questions/components/RelationInput.vue'

export default {
  name: 'Sort',
  changeExpr: 'changeExpr',
  changeDelay: true,
  components: {
    RelationInput,
    Draggable
  },
  data() {
    return {
      items: []
    }
  },
  created() {
    // this.issue.value = this.issue.value.filter(i => i.select)
    this.items = this.issue.items.slice().map(item => {
      return {
        select: false,
        ...item
      }
    })
  },
  computed: {
    changeExpr() {
      let items = this.issue.value.filter(item => item.select)
      return items.map(item => item.id + '|' + item.value).join('-')
    },
    disabled() {
      return this.issue.value.slice().filter(i => i.select).length >= this.issue.max_choice
    },
    maxChoice() {
      let val = parseInt(this.issue.max_choice) || -1
      return val > 0 ? val : this.items.length
    }
  },
  methods: {
    getLastSelectIndex() {
      for (let i = this.items.length - 1; i >= 0; i--) {
        let item = this.items[i]
        if (item.select) return i
      }
      return -1
    },
    onUpdateValue(item, index) {
      if (!item.isSelect) {
        let lastSelectIndex = this.getLastSelectIndex()
        item.isSelect = true
        if (lastSelectIndex > -1) {
          let res = this.items.splice(index, 1)
          this.items.splice(lastSelectIndex + 1, 0, ...res)
        } else {
          this.items.unshift(...this.items.splice(index, 1))
        }
      } else {
        item.isSelect = false
        this.items.push(...this.items.splice(index, 1))
      }

    },
    onLeftSortEnd() {
    },
    onSortEnd() {
      let value = this.issue.value
      value.forEach(v => (v.select = true))
    },
    onChangeState(item) {
      if(this.view ) return
      let selects = this.issue.value.slice()
      if (!item.select) {
        let len = selects.filter(i => i.select).length
        if (len >= this.issue.max_choice) return
      }
      let index = selects.findIndex(i => i.id === item.id)
      selects.splice(index, 1)
      item.select = !item.select
      let insertIndex = -1
      for (let i = 0; i < selects.length; i++) {
        let val = selects[i]
        if (!val.select) {
          insertIndex = i
          break
        }
      }
      if (insertIndex !== -1) {
        selects.splice(insertIndex, 0, item)
      } else {
        selects.push(item)
      }
      console.log(selects)
      this.issue.value = selects
    }
  }
}
</script>
